import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DirectivesModule } from '@shared/directives/directives.module';
import { FormWidgetDateRangeComponent } from '@bcm-work-flows/@form-widgets/date-range/form-widget-date-range.component';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [FormWidgetDateRangeComponent],
    imports: [
        FuseSharedModule,
        SharedModule,
        TranslationModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        DirectivesModule,
        DateTimeInputModule,
        MatTooltipModule,
    ],
    exports: [FormWidgetDateRangeComponent]
})
export class FormWidgetDateRangeModule {
    
}
